import { defineMessages } from 'react-intl';

const translations = {
  validatingMessage: {
    id: 'batchValidation.validatingMessage',
    defaultMessage: 'Your batch action is being validated.',
    description: 'validation message of the batch validation page',
  },
  validationSucceeded: {
    id: 'batchValidation.validationSucceeded',
    defaultMessage: 'Your batch is valid and can now be run.',
    description: 'validation success message of the batch valdidation page',
  },
  validationFailed: {
    id: 'batchValidation.validationFailed',
    defaultMessage: 'Your batch contains the following errors.',
    description: 'validation failed message of the batch valdidation page',
  },
};

export default defineMessages(translations);
